export default __webpack_public_path__ + "static/media/Dashboard_card3.d6ff5979.png";